'use client'

import type { PropsWithChildren } from 'react'

import 'core-js/actual/array/to-reversed'
import 'core-js/actual/array/to-sorted'
import 'core-js/actual/iterator'
import 'core-js/actual/map'

const PolyfillProvider = ({ children }: PropsWithChildren) => {
  return <>{children}</>
}

export default PolyfillProvider
